export const TeamworkGraphMarkBrandV3 = ({
	width = 32,
	height = 32,
}: {
	width?: number;
	height?: number;
} = {}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M22 22L10 10" stroke="#505258" strokeWidth="3" />
		<circle cx="7" cy="7" r="3.5" stroke="#1868DB" strokeWidth="3" />
		<circle cx="7" cy="25" r="3.5" stroke="#AF59E1" strokeWidth="3" />
		<circle cx="25" cy="25" r="3.5" stroke="#FCA700" strokeWidth="3" />
		<circle cx="25" cy="7" r="3.5" stroke="#6A9A23" strokeWidth="3" />
	</svg>
);
